import React from "react";

export default function Story2() {
  return (
    <div className="w-full flex md:flex-row flex-col justify-end items-center md:mr-40 md:gap-40 gap-10 z-50">
      <div
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-easing="ease-in-out"
        className="sm:w-1/3 border border-neutral-800 h-full"
      >
        <img
          src="./amadeus-3.png"
          className="w-full h-full"
          alt="story"
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className=" h-fit sm:w-2/4 flex justify-end items-end p-10 text-neutral-100"
      >
        <p className="sm:text-xl text-sm font-light tracking-wide leading-loose text-justify">
          As a guest speaker and honored guest at numerous
          shows, he has shared his passion and expertise
          through workshops and masterclasses that have
          shaped the skills of aspiring artists. His impact
          on the industry is evident, with his unique
          techniques—such as the Hairmony Eye Color Match,
          and many other innovations - being adopted by
          international hairdressers and makeup artists
          alike. Throughout this incredible journey, he has
          empowered over 2,000 students, enhancing their
          skills in in beauty and guiding them toward
          successful careers.
        </p>
      </div>
    </div>
  );
}
